export default "__VITE_ASSET__BEM59Mps__"